import { render } from "./LotSearch.vue?vue&type=template&id=61d5072f"
import script from "./LotSearch.vue?vue&type=script&lang=js"
export * from "./LotSearch.vue?vue&type=script&lang=js"
script.render = render

export default script